import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="py-2 border-t border-gray-800" data-id="element-92">
      <div className="max-w-5xl mx-auto text-center" data-id="element-93">
        <p className="text-xs text-gray-500" data-id="element-94">
          © 2025 Fan Collection Digital. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
};